import ExampleCodeBlock, {
  CodeParamType,
} from 'components/Docs/ExampleCodeBlock'

import { httpCodeExamples } from '../http-code-examples'

const js = `await integrationApp
  .integration('{INTEGRATION_KEY}')
  .getOperation('{OPERATION_KEY}')`

const rest = httpCodeExamples(
  '/integrations/{INTEGRATION_KEY}/operations/{OPERATION_KEY}',
)

export function GetOperationCodeExample() {
  return (
    <ExampleCodeBlock
      customCodes={{ js, ...rest }}
      parameters={{
        INTEGRATION_KEY: CodeParamType.IntegrationKey,
        OPERATION_KEY: CodeParamType.String,
      }}
      run={async ({ integrationApp, parameters }) => {
        return await integrationApp
          .integration(parameters.INTEGRATION_KEY)
          .getOperation(parameters.OPERATION_KEY)
      }}
    />
  )
}
